import { useEffect } from "react";
import { useActionStatus, onActionFinished } from "../hooks/useActions";
import { usePipeline } from "../store/pipeline";
import { useToast } from "../store/toast";

export function PipelineBanner() {
  const runId = usePipeline((s) => s.runId);
  const label = usePipeline((s) => s.label);
  const clearRun = usePipeline((s) => s.clearRun);
  const toast = useToast((s) => s.push);

  const { data, isFetching } = useActionStatus(runId, runId != null);

  useEffect(() => {
    if (!data?.completed || runId == null) return;
    const ok = data.success;
    const href = data.run.html_url;
    if (ok) {
      toast("Pipeline completed — refreshing data", { kind: "success", href, durationMs: 8000 });
    } else {
      toast(`Pipeline: ${data.run.conclusion ?? "failed"}`, { kind: "error", href, durationMs: 10000 });
    }
    onActionFinished(ok).finally(() => clearRun());
  }, [data?.completed, data?.success, data?.run.conclusion, data?.run.html_url, runId, toast, clearRun]);

  if (runId == null) return null;

  const completed = data?.completed;
  const status = data?.run.status ?? "queued";
  const conclusion = data?.run.conclusion;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[60] border-t border-fg bg-bg px-4 py-3 font-mono text-[11px] uppercase tracking-[0.12em] flex flex-wrap items-center gap-3 shadow-[0_-4px_0_0_var(--fg)]"
      role="status"
      aria-live="polite"
    >
      <span className="font-medium text-fg">
        // Pipeline {label ? `· ${label}` : ""} · run #{runId}
      </span>
      {!completed && (
        <span className="text-muted animate-pulse">
          {isFetching ? `${status}…` : "polling…"}
        </span>
      )}
      {completed && (
        <span className={data?.success ? "text-good" : "text-bad"}>
          {conclusion ?? (data?.success ? "success" : "failed")}
        </span>
      )}
      {data?.run.html_url && (
        <a
          href={data.run.html_url}
          target="_blank"
          rel="noopener noreferrer"
          className="border border-fg px-2 py-1 hover:bg-fg hover:text-bg"
        >
          GitHub run ↗
        </a>
      )}
      <button
        type="button"
        onClick={() => clearRun()}
        className="ml-auto border border-fg px-2 py-1 hover:bg-fg hover:text-bg"
      >
        Dismiss
      </button>
    </div>
  );
}